import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Divider, Stack } from '@mui/material';

import { Comment as CommentType } from '../../../../../../db/comments/types';
import { i18nNS } from '../../../../../../i18n';
import Comment from './Comment';
import CommentCreator from './Comment/CommentCreator';
import { NewIndicator, NewIndicatorWrapper, Root } from './styles';
import useCommentGroupVM from './vm';

interface Props {
  commentGroup: CommentType[];
  groupId: string;
}

const CommentGroup = ({ commentGroup, groupId }: Props) => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  const { newIndicatorWrapperRef, firstUnseenCommentId, newIndicatorRef } = useCommentGroupVM();

  return (
    <Root aria-labelledby={commentGroup.length > 1 ? groupId : undefined}>
      <div id={groupId} className="sr-only" aria-hidden>
        {t('comment_group_with_N_comments', { ns: i18nNS.COMMENTS, count: commentGroup.length })}
      </div>
      <CommentCreator creator={commentGroup[0].createdBy} createdOn={commentGroup[0].createdOn} />
      <Stack direction="column-reverse" gap={3}>
        {commentGroup.map((comment, index, self) => (
          <Fragment key={comment.id}>
            <Comment commentId={comment.id} isOnlyCommentInGroup={self.length === 1} />
            {commentGroup.length > 1 && firstUnseenCommentId === comment.id ? (
              <div ref={newIndicatorWrapperRef}>
                <NewIndicator
                  ref={newIndicatorRef}
                  color="warning"
                  rightLabel={t('new', { ns: i18nNS.GLOSSARY })}
                  rightAriaLabel={t('new_comments_indicator', { ns: i18nNS.COMMENTS })}
                />
              </div>
            ) : (
              !comment.isFirstCommentInGroup && <Divider />
            )}
          </Fragment>
        ))}
      </Stack>
      {commentGroup.length === 1 && firstUnseenCommentId === commentGroup[0].id && (
        <NewIndicatorWrapper ref={newIndicatorWrapperRef}>
          <NewIndicator
            ref={newIndicatorRef}
            color="warning"
            rightLabel={t('new', { ns: i18nNS.GLOSSARY })}
            rightAriaLabel={t('new_comments_indicator', { ns: i18nNS.COMMENTS })}
          />
        </NewIndicatorWrapper>
      )}
    </Root>
  );
};

export default CommentGroup;
